import {AnalyticsMetadataForContext} from 'analytics/AnalyticsTypes';
import * as net from 'util/Net';

export interface CreateAntibodyFormatInput {
  veritasName: string;
  displayName?: string;
}

export function createAntibodyFormat(
  input: CreateAntibodyFormatInput,
  analyticsMetadata?: AnalyticsMetadataForContext
): Promise<{antibodyFormatId: string}> {
  return net.postJSONPromise({
    url: '/1/api/antibody-formats',
    data: input,
    analyticsMetadata,
  });
}

export function updateAntibodyFormatDisplayName(
  formatId: string,
  displayName: string
): Promise<{updatedIds: Array<string>}> {
  return net.patchJSONPromise({
    url: '/1/api/antibody-formats',
    data: {updates: [{id: formatId, displayName}]},
  });
}
